export default __webpack_public_path__ + "static/media/multi.8c3bd7ee.png";